export default __webpack_public_path__ + "static/media/bg-masthead-2-800w.03d2f508.jpg";